import request, {METHODS} from "@/api";
import UrlConfig from "@/api/UrlConfigs";
import {get} from "lodash-es";

export const fetchCustomerTalkOrderPage = (query: { data: {} }) => {
  return request(UrlConfig.Deal.GetDealkingTalkOrderPage, {
    method: METHODS.POST,
    ...query, data: {isDataPermissions: true, ...query.data}
  }).then(res => {
    const records = get(res, 'list', []);
    const total = get(res, 'count', 0);
    return {records, total}
  }).catch(() => ({}))

}

export const saveNegotiate = (params = {}) => {
  return request(UrlConfig.Deal.DealkingTalkOrder, {
    method: METHODS.POST,
    ...params
  })
}

export const updateNegotiate = (params = {}) => {
  return request(UrlConfig.Deal.UpdateDealkingTalkOrder, {
    method: METHODS.POST,
    ...params
  })
}

/**
 *  客户信息 分页
 * @param query
 */
export const getCustomerPage = (query: {}) => {
  return request(UrlConfig.Clue.SearchCustomerPage, {
    method: METHODS.POST,
    ...query
  }).then(res => {
    const records = get(res, 'list', []);
    const total = get(res, 'count', 0);
    return {records, total}
  }).catch(() => ({}))
}

/**
 * 线索信息 分页
 * @param query
 */
export const getCluePage = (query: {}) => {
  return request(UrlConfig.Clue.SearchClueInfoPage, {
    method: METHODS.POST,
    ...query
  }).then(res => {
    const records = get(res, 'list', []);
    const total = get(res, 'count', 0);
    return {records, total}
  }).catch(() => ({}))
}

/**
 * 获取文件前缀
 */
export const getFileUrlPrefix = () => {
  return request(UrlConfig.File.FetchUnifiedProfile, {
    method: METHODS.GET
  }).then((res) => res || '').catch(() => '')
};


/**
 * 查询客户报告
 */
export const getMeetReport = (id: string | number) => {
  return request(UrlConfig.Deal.GetCustemerCase + id, {
    method: METHODS.GET
  }).then((res) => res || [])
};


/**
 * 保存见面报告
 */
export const saveMeetReport = (params: any) => {
  return request(UrlConfig.Deal.UpdateDealkingTalkOrder, {
    method: METHODS.POST,
    ...params,
  }).then((res) => res || '').catch(() => '')
};
